// src/pages/gears/Neo.js

import "../../App.css";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import BackOnly from "../../components/BackOnly";
import ContactPopup from "../../components/ContactPopup";
import AffiliateAmazon from "../../components/affiliate/AffiliateAmazon";
import AffiliateEbay from "../../components/affiliate/AffiliateEbay";
import React, { useState } from "react";

// ⭐ IMPORT ONLY THE IMAGES YOU NEED
import x2 from "./gearimages/x2.jpg";
import x2scr from "./gearimages/x2scr.jpg";

export default function InstaX2() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>

      <div className="page-container" style={{ padding: "10px" }}>
        <section className="gear-review">

          {/* ⭐ NEW GEAR LAYOUT */}
          <div className="gear-container">

            {/* LEFT COLUMN */}
            <div className="gear-left">
              <h1>Insta360 One X2</h1>

              <p>
                The Insta360 X2 is a compact 360° camera that delivers impressive image quality
                in a pocket‑sized body. It shoots 5.7K 360 video with excellent stabilization,
                making it ideal for travel, action sports, and creative storytelling where you
                want to capture everything around you and reframe later.
              </p>

              <p>
                Its waterproof design (up to 10 m) and rugged build make it a solid choice for
                outdoor adventures. Features like FlowState stabilization, horizon leveling, and
                multiple shooting modes (including Steady Cam mode for single‑lens video) give
                you a lot of flexibility without needing a big setup.
              </p>

              <div className="place-block">
                <ul>
                  <li>5.7K 360° video at up to 30fps</li>
                  <li>FlowState stabilization with horizon leveling</li>
                  <li>Waterproof up to 10 m (without case)</li>
                  <li>Touchscreen display for framing and control</li>
                  <li>4‑mic 360 audio with wind reduction</li>
                  <li>TimeShift, hyperlapse, and slow‑motion modes</li>
                  <li>Invisible selfie stick effect for clean shots</li>
                  <li>Approx. 80 minutes of recording per charge (varies by mode)</li>
                  <li>Works with Insta360 app for reframing and editing</li>
                </ul>
              </div>

              <AffiliateAmazon
                title="Check price on Amazon"
                link="https://amzn.to/3PYA62q"
              />

              {/* TODO: Update this eBay link to a proper Insta360 X2 search URL */}
              {/* Example placeholder:
                  https://www.ebay.com/sch/i.html?_nkw=Insta360+X2&_sacat=0&_sop=12
              */}
              <AffiliateEbay
              title="Check price on eBay"
                link="https://ebay.us/Ra0W4W"
              />
            </div>

            {/* RIGHT COLUMN */}
            <div className="gear-right">
              <img src={x2} alt="Insta360 X2 camera" />
              <img src={x2scr} alt="Insta360 X2 screen" />
            
            </div>
            
            

          </div>
        </section>
      </div>

      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
